<template>
  <section v-if="variations.length" class="layout-grid paragraph">
    <DynamicFontSizeHeading
      class="col-start-2 col-end-7 mb-32 font-light uppercase md:col-start-3 md:col-end-[-1] md:w-[32em]"
    >
      {{ title }}
    </DynamicFontSizeHeading>
    <div
      v-if="variations.length"
      class="col-span-full col-start-2 md:col-start-3 md:col-end-[-1]"
    >
      <InputDropdown
        v-if="options && options?.length > 1"
        v-model="selectedValue"
        class="col-span-full col-start-2 mb-40 w-[195px] md:col-start-3 md:w-[286px]"
        :items="options"
      />
      <ProductVariationSlider :items="variations">
        <template #item="variation">
          <ProductVariationTeaser
            :variation="variation"
            :strap="straps"
            :class="{
              'md:w-[396px]': variations?.length === 3,
              'md:w-[416px]': variations?.length !== 3,
            }"
            class="mobile-only:w-[289px]"
            :no-limited-pill="noLimitedPill"
          />
        </template>
      </ProductVariationSlider>
    </div>
  </section>
</template>

<script setup lang="ts">
import type {
  ProductFinderItemFragment,
  ProductVariationStrapTeaserFragment,
  ProductVariationWatchTeaserFragment,
} from '#build/graphql-operations'
import type { DropdownItem } from '~/components/Input/Dropdown.vue'

const props = defineProps<{
  variations: (
    | ProductVariationWatchTeaserFragment
    | ProductVariationStrapTeaserFragment
    | ProductFinderItemFragment
  )[]
  title: string
  noLimitedPill?: boolean
  options?: DropdownItem[]
}>()

const selectedValue = defineModel<string | number | undefined | null>()

const straps = computed(() =>
  props.variations.every((v) => {
    if ('__typename' in v) {
      // ProductVariationWatchTeaserFragment or ProductVariationStrapTeaserFragment
      return v.__typename === 'CommerceProductVariationStrapDefault'
    } else {
      // LimitedEditionItemFragment
      return !('isLimitedEdition' in v) // straps do not have this field
    }
  }),
)
</script>

<style lang="scss" scoped>
@import '~/helpers/helpers';

h2 {
  font-size: between-mobile-desktop(48px, 80px);
  line-height: 1.11;
}
</style>
